import { commandsStore } from "@/store/commandsStore";
import { gptStore } from "@/store/gptStore";
import { isAuctionController, isGPT, isSlotDiscovery, isStartCommand, } from "@/ts/guards";
import type { IModule, SequenceControllerModule } from "@/ts/module";
import type { CustomDoc, Exactly, SlotTargeting, StartCommand, } from "@/ts/types";
import { getModules } from "@/utils/modules";
export class SequenceController implements Exactly<SequenceControllerModule, SequenceController> {
    private modules: IModule[] = [];
    name = "SequenceController" as const;
    async init(): Promise<void> {
        this.modules = await getModules([
            "SlotDiscovery",
            "AuctionController",
            "GPT",
        ]);
        const { selectStartCommand } = commandsStore.getState().selectors;
        commandsStore.subscribe(selectStartCommand, (selectedCmd) => {
            if (selectedCmd) {
                handleStartCommand(this.run.bind(this), selectedCmd);
            }
        });
    }
    async run(commandId: number, doc: CustomDoc) {
        const { promise, resolve } = Promise.withResolvers<Record<string, SlotTargeting> | undefined>();
        let auctionTargeting: Record<string, SlotTargeting> | undefined;
        for (const mod of this.modules) {
            if (isSlotDiscovery(mod)) {
                await mod.run(commandId, doc);
            }
            if (isAuctionController(mod)) {
                const { selectors } = gptStore.getState();
                // pass undefined to let AuctionController choose the default timeout value
                mod.run(selectors.getSlotConfigsByCommandId(commandId), resolve, undefined);
                auctionTargeting = await promise;
            }
            if (isGPT(mod)) {
                await mod.run(commandId, auctionTargeting);
            }
        }
        return Promise.resolve(true);
    }
}
const handleStartCommand = (run: (startCommandId: number, doc: CustomDoc) => void, selectedCmd?: StartCommand) => {
    if (selectedCmd && isStartCommand(selectedCmd)) {
        const { doc } = selectedCmd;
        return run(selectedCmd.id, doc);
    }
};
